import React from "react";
import BannerSection from "../Component/BannerSection";
import Layout from "../Component/Layout/Layout";

const PrivacyPOlicy = () => {
  return (
    <Layout>
      <BannerSection
        title="Home"
        image="/images/product&service_banner.jpeg"
        description="Privacy Policy"
        heading="Privacy Policy"
      />
      <div className="container my-5">
        <h1 className="mb-4 text-start fw-bold">Privacy Policy</h1>

        <div className="mb-4">
          <p>
            Afrikan BBQ LLC <strong>"we," "us," "our"</strong> operates the
            Afrikan BBQ website the <strong>"Site"</strong> . This page informs
            you of our policies regarding the collection, use, and disclosure of
            Personal Information we receive from users of the Site.
          </p>
        </div>

        <h2 className="mt-4 mb-3 fw-bold">Information Collection and Use</h2>
        <p>
          While using our Site, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you. Personally identifiable information may include, but is
          not limited to, your name, email address, postal address, and phone
          number <strong>"Personal Information"</strong> .
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Log Data</h2>
        <p>
          Like many site operators, we collect information that your browser
          sends whenever you visit our Site <strong>"Log Data"</strong> . This
          Log Data may include information such as your computer's Internet
          Protocol <strong>"IP"</strong> address, browser type, browser version,
          the pages of our Site that you visit, the time and date of your visit,
          the time spent on those pages, and other statistics.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Cookies</h2>
        <p>
          Cookies are files with small amounts of data, which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          website and stored on your computer's hard drive. Like many sites, we
          use
          <strong> "cookies"</strong> to collect information. You can instruct
          your browser to refuse all cookies or to indicate when a cookie is
          being sent. However, if you do not accept cookies, you may not be able
          to use some portions of our Site.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Security</h2>
        <p>
          The security of your Personal Information is important to us but
          remember that no method of transmission over the Internet, or method
          of electronic storage, is 100% secure. While we strive to use
          commercially acceptable means to protect your Personal Information, we
          cannot guarantee its absolute security.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Changes to This Privacy Policy</h2>
        <p>
          Afrikan BBQ LLC may update this Privacy Policy from time to time. We
          will notify you of any changes by posting the new Privacy Policy on
          the Site. You are advised to review this Privacy Policy periodically
          for any changes.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at:
        </p>
        <div className="mb-4">
          <p>
            <strong>Afrikan BBQ LLC</strong>
          </p>
          <p>
            Address:{" "}
            <a
              href="https://www.google.com/maps/place/3118+E+Baldwin+Ave,+Spokane,+WA+99207"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-danger"
            >
              3118 E Baldwin Ave, Spokane, WA 99207
            </a>
          </p>
          <p>
            Email:{" "}
            <a
              href="mailto:Info@afrikanbbq.com"
              className="text-decoration-none text-danger"
            >
              Info@afrikanbbq.com
            </a>
          </p>
          <p>
            Phone:{" "}
            <a
              href="tel:+15096012505"
              className="text-decoration-none text-danger"
            >
              509-601-2505
            </a>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPOlicy;
